import React, { Fragment } from "react";
import PropTypes from "prop-types";
import {
  deleteNotification,
  deleteNotifications,
} from "../../../actions/notification";
import { connect } from "react-redux";

import NotificationItem from "./NotificationItem";

const ProfileNotifications = ({
  setnotificationsOpen,
  deleteNotification,
  deleteNotifications,
  notifications,
}) => {
  return (
    <Fragment>
      <div className="notification-overlay">
        <div className="notification-box-container">
          <div className="close-x" onClick={() => setnotificationsOpen(false)}>
            <i className="far fa-times-circle fa-3x green"></i>
          </div>
          <div className="notification-box" id="green-scroll">
            <div className="notifications-title green">
              <i className="fas fa-bell fa-lg green mx-5"></i>
              Notifications
              {notifications.length > 0 && (
                <span onClick={() => deleteNotifications()} className="clear">
                  <i className="far fa-times-circle fa-sm mr-2 green"></i>
                  Clear All
                </span>
              )}
            </div>
            <div className="all-notifications" id="green-scroll">
              {notifications.length < 1 && (
                <div className="no-notifications">
                  <div>
                    <span className="white bold">No Notifications</span>
                  </div>
                  <i className="fas fa-envelope-open fa-3x green mt-10"></i>
                </div>
              )}
              {notifications.map((notification) => {
                return (
                  <NotificationItem
                    key={notification._id}
                    notification={notification}
                    setnotificationsOpen={setnotificationsOpen}
                    deleteNotification={deleteNotification}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

ProfileNotifications.propTypes = {
  auth: PropTypes.object.isRequired,
  deleteNotification: PropTypes.func.isRequired,
  deleteNotifications: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  deleteNotification,
  deleteNotifications,
})(ProfileNotifications);
